import { PublicInstitution } from './../../models/PublicInstitution';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InstitutionsService {

  private publicInstitutions = new BehaviorSubject<PublicInstitution[]>(null);
  broadCast = this.publicInstitutions.asObservable();

constructor() {

 }
 UpdateInstitutions(newInstitutions : PublicInstitution[]){
   this.publicInstitutions.next(newInstitutions);
 }

}
